import styled from '@emotion/styled'

export const StatusTagWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  display: flex;
  /* z-index: 0; */
`

export const StatusTag = styled.div<{ textColor: string; bgColor: string }>`
  background-color: ${({ theme, bgColor }: any) =>
    theme.colors[bgColor] || bgColor};
  color: ${({ theme, textColor }: any) => theme.colors[textColor] || textColor};
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
`

export const Dropdown = styled.ul`
  position: absolute;
  top: 100%;
  margin-top: 6px;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  z-index: 10;
  min-width: 120px;
  padding: 6px 5px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const DropdownItem = styled.li<{ textColor: string; bgColor: string }>`
  padding: 8px 12px;
  font-size: 13px;
  text-transform: capitalize;
  cursor: pointer;
  color: ${({ theme, textColor }: any) => theme.colors[textColor] || textColor};
  background-color: ${({ theme, bgColor }: any) =>
    theme.colors[bgColor] || 'transparent'};

  &:hover {
    background-color: ${({ theme }: any) => theme.colors.borderColor || '#eee'};
  }
`
